module.exports = __webpack_public_path__ + "static/media/HTC One M8 Silver.22a89848.png";